import React from "react";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { history } from "../../../../../../history";
import { Box } from "../../../../../../shared/Box/Box";
import { StaticReportsBox } from "../../../../../BusinessInsights/components/StaticReportsBox/StaticReportsBox";

export function StaticReports() {
  const { tBi } = useAppTranslation.BusinessInsights();

  const reports = [
    {
      key: 1,
      label: tBi("liabilityReports.expired.label"),
      isVisible: true,
      onClick: () =>
        history.push(
          "/refactor-business-insight/sales/short_term_liability/expired",
        ),
    },
    {
      key: 2,
      label: tBi("liabilityReports.expiring.label"),
      isVisible: true,
      onClick: () =>
        history.push(
          "/refactor-business-insight/sales/short_term_liability/expiring",
        ),
    },
  ];

  return <StaticReportsBox noLabel reports={reports} Wrapper={Box} />;
}
